import { render, staticRenderFns } from "./AdminOrderList.vue?vue&type=template&id=52787ae4&scoped=true"
import script from "./AdminOrderList.vue?vue&type=script&lang=js"
export * from "./AdminOrderList.vue?vue&type=script&lang=js"
import style0 from "./AdminOrderList.vue?vue&type=style&index=0&id=52787ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52787ae4",
  null
  
)

export default component.exports